let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fIHvG")).then(() => parcelRequire('QyFnn'));